import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
    NavItem,
    Nav,
    Card
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';

export default function ImageWithTextWithCardPadding({
    global,
    pathPrefix,
    customClass = "",
    content,
    post,
    buttonLink,
    buttonTitle,
    transparent_card = false,
    post_button_url_slug,
    enableContent = false,
    previewImage = false
}) {

    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass} ${transparent_card ? "transparent-card" : null}`} >
                <Container>
                    {content ?
                        <div className="text-center mb-5">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                {content}
                            </SourceFlowText>
                            {buttonLink ?
                                <div>
                                    <Link href={`${buttonLink}`}>
                                        <a className="primaryBtn no-arrow">
                                            {buttonTitle}
                                        </a>
                                    </Link>
                                </div> : null}
                        </div>
                        : null}

                    {post?.map((post, index) => (
                        <div key={index} className={`${transparent_card ? "" : "border rounded-4"} post-item overflow-hidden mb-4`}>
                            <Row className={`m-0 ${transparent_card ? "align-items-center" : ""}`}>
                                <Col md={7} lg={8} xl={10} className={`p-md-5 p-4 ${transparent_card ? "" : "bg-white"}`}>
                                    <p className="fs-3"><strong>{post.title}</strong></p>
                                    {post?.short_description ?
                                        <div className="mt-3" dangerouslySetInnerHTML={{ __html: post?.short_description }} />
                                        : null}
                                    {enableContent ?
                                        post?.content ?
                                            <div className="mt-3" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                            : null : null
                                    }
                                    {post_button_url_slug ?
                                        <div className="mt-5">
                                            <Link href={`${post?.url_slug}`}>
                                                <a className="primaryBtn no-arrow m-0">
                                                    {post?.button_title}
                                                </a>
                                            </Link>
                                        </div> :
                                        post?.button_link ?
                                            <div className="mt-5">
                                                {post?.link_email ?
                                                    <a className="primaryBtn no-arrow m-0" href={`mailto:${post?.button_link}`}>
                                                        {post?.button_title}
                                                    </a> :
                                                    post?.button_new_tab ?
                                                        <Link href={`${post?.button_link}`}>
                                                            <a className="primaryBtn no-arrow m-0" target="_blank" rel="noreferrer noopener">
                                                                {post?.button_title}
                                                            </a>
                                                        </Link> :
                                                        <Link href={`${post?.button_link}`}>
                                                            <a className="primaryBtn no-arrow m-0">
                                                                {post?.button_title}
                                                            </a>
                                                        </Link>}
                                            </div> : null}

                                </Col>
                                <Col md={5} lg={4} xl={2} className="p-0 position-relative">
                                    <SourceFlowImage
                                        src={previewImage && post?.preview_image ? post?.preview_image : post?.image ? post?.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                        size="500x500"
                                        alt={post?.title}
                                        className="card-img"
                                    />
                                </Col>
                            </Row>
                        </div>
                    ))}
                </Container>
            </section>
        )
    )
}